import * as React from 'react';

const PaginationBar = ({ rowsPerPage, totalRows, paginate, currentPage }) => {
    const pageNumbers = [];
    let nTotalPageDisplay = process.env.REACT_APP_TOTALPAGEDISPLAY ? parseInt(process.env.REACT_APP_TOTALPAGEDISPLAY) : 10;
    let nTotalPage = Math.ceil(totalRows / rowsPerPage);

    for (let i = 1; i <= nTotalPage; i++) {
        if (nTotalPage > nTotalPageDisplay) {
            let isShowPage = false;
            if (i <= 5 || i > (nTotalPage - 3) || i === currentPage || i === (currentPage + 1) || i === (currentPage - 1)) {
                isShowPage = true;
            }
            if (!isShowPage) {
                if (pageNumbers.length < nTotalPageDisplay) {
                    let nRemaining = nTotalPageDisplay - pageNumbers.length;
                    if ((nTotalPage - i) < nRemaining) {
                        isShowPage = true;
                    }
                }
            }
            if (isShowPage) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(i);
        }
    };

    const handleClick = (e, number) => {
        e.preventDefault(); // Prevent default anchor behavior
        paginate(number);
    };

    const goToPrevPage = (e) => {
        e.preventDefault();
        if (currentPage > 1) {
            paginate(currentPage - 1);
        }
    };

    const goToNextPage = (e) => {
        e.preventDefault();
        if (currentPage < nTotalPage) {
            paginate(currentPage + 1);
        }
    };

    return (
        <nav>
            <ul className="pagination">
                <li
                    key={0}
                    className={`page-item`}
                >
                    <a
                        onClick={(e) => goToPrevPage(e)}
                        href="!#"
                        className="page-link"
                    >
                        {'<'}
                    </a>
                </li>

                {pageNumbers.map((number) => (
                    <li
                        key={number}
                        className={`page-item ${currentPage === number ? "active" : ""}`}
                    >
                        <a
                            onClick={(e) => handleClick(e, number)} // Added e.preventDefault()
                            href="!#"
                            className="page-link"
                        >
                            {number}
                        </a>
                    </li>
                ))}

                <li
                    key={nTotalPage + 1}
                    className={`page-item`}
                >
                    <a
                        onClick={(e) => goToNextPage(e)}
                        href="!#"
                        className="page-link"
                    >
                        {'>'}
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default PaginationBar;